import React from 'react'
import { compose } from '@cbgms/base/utils/compose'
import { Redirect, Switch } from 'react-router-dom'
import CompanyEdit from './Edit'
import CompanyNew from './New'
import ShopEdit from 'app-support/shops/components/Edit'
import ShopNew from 'app-support/shops/components/New'
import List from './List'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'
import NewLicense from 'app-support/company/components/Licenses/NewLicense'
import EditLicense from './Licenses/EditLicense'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_COMPANIES } from 'app-support/permissions/Permissions'
import {
  companiesRoute,
  companiesRouteEdit,
  companiesRouteNew,
  companyLicensesRoute,
  companyLicensesRouteEdit,
  companyLicensesRouteFallback,
  companyLicensesRouteNew,
  shopsRoute,
  shopsRouteCompanies,
  shopsRouteEdit,
  shopsRouteNew
} from 'routes/routeNames'

const enhance = compose(withRegionSwitchHandler(companiesRoute))

export const CompanyContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={companiesRouteNew} component={CompanyNew} />
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={companiesRouteEdit} component={CompanyEdit} />
    <Redirect exact path={companyLicensesRoute} to={companyLicensesRouteFallback} />
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={companyLicensesRouteEdit} component={EditLicense} />
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={companyLicensesRouteNew} component={NewLicense} />
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={shopsRouteNew} component={ShopNew} />
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={shopsRouteEdit} component={ShopEdit} />
    <PermissionRoute permission={PERMISSION_MANAGE_COMPANIES} exact path={companiesRoute} component={List} />
    <Redirect exact path={shopsRouteCompanies} to={shopsRoute} />
  </Switch>
)

export default enhance(CompanyContainer)
